<div class="god-mode-idle-dialog" role="alertdialog" aria-live="assertive">
  <div class="god-mode-idle-dialog__header">
    <mat-icon>warning</mat-icon>
    <h2 mat-dialog-title>Leaving god mode warning</h2>
  </div>

  <mat-dialog-content>
    <p>God mode is about to be disabled because no mouse activity was detected.</p>
    <div class="god-mode-idle-dialog__counter" aria-label="Seconds remaining">
      {{ secondsRemaining }}
    </div>
    <p>If no action is taken, god mode will be disabled automatically.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" type="button" (click)="leave()">Leave god mode</button>
    <button mat-raised-button color="primary" type="button" (click)="stay()" cdkFocusInitial>Stay in god mode</button>
  </mat-dialog-actions>
</div>
